// extracted by mini-css-extract-plugin
export default {"button":"ChainSelect_button__XL48C","icon":"ChainSelect_icon__FzEMM"};